import create from "zustand";
import produce from "immer";
import { devtools, persist } from "zustand/middleware";

type SelectedCurrencyCodeState = {
  selectedCurrencyCode: string | undefined;
  setSelectedCurrencyCode: (selectedCurrencyCode: string | undefined) => void;
};

const useSelectedCurrencyCodeStore = create<SelectedCurrencyCodeState>()(
  devtools(
    persist(
      (set) => ({
        selectedCurrencyCode: undefined,
        setSelectedCurrencyCode: (selectedCurrencyCode) =>
          set(produce((state) => ({ ...state, selectedCurrencyCode }))),
      }),
      {
        name: "Workspace/SelectedCurrency",
      }
    )
  )
);

export const useSelectedCurrencyCode = () => {
  const { selectedCurrencyCode, setSelectedCurrencyCode } =
    useSelectedCurrencyCodeStore();
  return [selectedCurrencyCode, setSelectedCurrencyCode] as const;
};
